import { useEffect, useRef, useState } from "react";
import { RefreshCw, Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { dtt } from "./shared";

const Bar = ({ pct, color, testid }) => (
  <div className="h-1.5 w-full overflow-hidden rounded-full bg-neutral-800">
    <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${Math.min(100, pct)}%`, background: color }} data-testid={testid} />
  </div>
);

export function SyncBar({ initial, reload, openParents }) {
  const [s, setS] = useState(initial || {});
  const was = useRef(!!initial?.running);
  useEffect(() => {
    if (!s.running) return;
    const t = setInterval(() => api.get("/monitoring/sync-status").then((r) => {
      setS(r.data);
      if (was.current && !r.data.running) { reload(); toast.success("Sincronizzazione FIER completata"); }
      was.current = r.data.running;
    }).catch(() => {}), 3000);
    return () => clearInterval(t);
  }, [s.running]); // eslint-disable-line react-hooks/exhaustive-deps
  const run = async () => {
    try { await api.post("/monitoring/sync"); was.current = true; setS((x) => ({ ...x, running: true, progress: { fase: "Avvio…", fatto: 0, totale: 1 } })); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  const p = s.progress;
  const cov = s.totale_account ? (s.con_dettagli / s.totale_account) * 100 : 0;
  return (
    <div className="space-y-3 rounded-xl border border-neutral-800 bg-neutral-950 p-3 text-xs text-neutral-400" data-testid="monitoring-sync-bar">
      <div className="flex flex-wrap items-center gap-3">
        <span data-testid="monitoring-sync-status">{s.running ? <span className="inline-flex items-center gap-1.5 text-white"><Loader2 className="h-3.5 w-3.5 animate-spin" />Sincronizzazione in corso</span>
          : s.last_ok ? `Ultima sincronizzazione FIER: ${dtt(s.last_ok)} · ${s.utenti || 0} account` : "Mai sincronizzato"}</span>
        {s.error && !s.running && <span className="text-red-400" data-testid="monitoring-sync-error">Errore: {s.error}</span>}
        <span className="ml-auto flex gap-2">
          <button type="button" onClick={run} disabled={s.running} data-testid="monitoring-sync-btn" className="inline-flex items-center gap-1 rounded-full border border-neutral-700 px-3 py-1 font-bold text-neutral-200 hover:border-neutral-400 disabled:opacity-40"><RefreshCw className="h-3.5 w-3.5" />Sincronizza ora</button>
          <button type="button" onClick={openParents} data-testid="monitoring-parents-btn" className="inline-flex items-center gap-1 rounded-full border border-neutral-700 px-3 py-1 font-bold text-neutral-200 hover:border-neutral-400"><Link2 className="h-3.5 w-3.5" />Abbinamenti installatori</button>
        </span>
      </div>
      {s.running && p && (
        <div className="space-y-1" data-testid="monitoring-sync-progress">
          <div className="flex justify-between"><span className="text-neutral-200" data-testid="monitoring-sync-phase">{p.fase}</span><span className="font-mono">{p.fatto}/{p.totale}</span></div>
          <Bar pct={p.totale ? (p.fatto / p.totale) * 100 : 0} color="hsl(48 98% 50%)" testid="monitoring-sync-progress-fill" />
        </div>
      )}
      <div className="space-y-1" data-testid="monitoring-sync-coverage">
        <div className="flex justify-between"><span>Dettagli impianti letti (inverter, SN, installatore)</span><span className="font-mono" data-testid="monitoring-sync-coverage-count">{s.con_dettagli || 0}/{s.totale_account || 0}</span></div>
        <Bar pct={cov} color="#22c55e" testid="monitoring-sync-coverage-fill" />
      </div>
    </div>
  );
}
